module.exports = __webpack_public_path__ + "img/bx-share-alt.b386cb36.svg";